import {
  createMallEventLogContextFromNuxtStore,
  initializeMallEventLog,
  mallAnalyticsLogEvent,
  mallAnalyticsLogScreenView,
  setMallEventLogContextProvider,
} from "../utils/mallEventLog.js";
import { useMainStore } from "../composables/store";
import { getCurrentServer } from "../utils/globalData";

export default defineNuxtPlugin((nuxtApp) => {
  const store = useMainStore();

  setMallEventLogContextProvider(() => (
    createMallEventLogContextFromNuxtStore(store, getCurrentServer())
  ));

  initializeMallEventLog();
  mallAnalyticsLogEvent("app_init", {
    init_success: true,
    screenName: window.location.pathname || "/",
    pageCode: "app",
    platform: "web",
  });

  const router = nuxtApp.$router;
  const currentRoute = router?.currentRoute?.value;
  if (currentRoute) {
    mallAnalyticsLogScreenView(
      currentRoute.path || currentRoute.name || window.location.pathname || "unknown_page",
      {
        ...(currentRoute.query || {}),
        path: currentRoute.path,
        fullPath: currentRoute.fullPath,
      },
    );
  }
  if (router?.afterEach) {
    router.afterEach((to, from) => {
      mallAnalyticsLogScreenView(
        to?.path || to?.name || "unknown_page",
        {
          ...(to?.query || {}),
          path: to?.path,
          fullPath: to?.fullPath,
        },
        from?.path || from?.name,
        from?.fullPath,
      );
    });
  }

  nuxtApp.provide("mallEventLog", {
    initialize: initializeMallEventLog,
    logEvent: mallAnalyticsLogEvent,
    logScreenView: mallAnalyticsLogScreenView,
  });
});
